<template>
  <div class="item" >
    <a class="avatar"><img :src="data['图片']"></a>
    <h3>{{data.name}}</h3>
    <h4>{{data.company}}</h4>
    <h4>{{data.position}}</h4>
  </div>
</template>

<script>
  export default {
    name: 'Speaker',
    props: [
      'data'
    ],
    data () {
      return {
      }
    },
    computed: {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
    }
  }
</script>

<style lang="sass" scoped>

  @import "../../style/variable"

  .item
    text-align: center
    .avatar
      display: block
      border-radius: 50%
      width: 70%
      height: 0
      margin: 0 auto
      cursor: default
      transition: all $speed
      background-color: #fff
      border: 1px solid $grey-lighter
      position: relative
      padding-bottom: 70%
      +mobile
        height: 0
      //&:hover
        box-shadow: 0 0 1px $grey-light, 0 0 28px $grey-lighter
      img
        position: absolute
        width: 100%
        height: 100%
        border-radius: 50%
        display: block
        padding: 5px
    h3
      margin-top: 21px
      margin-bottom: 14px
      font-size: 18px
      font-weight: 600
      color: $primary
      +mobile
        margin-top: 10px
        margin-bottom: 4px
    h4
      font-size: 13px
      line-height: 1.45em
      color: $main-font-color
  .item.dark
    h3
      color: $primary
    h4
      color: $main-font-color
    .avatar
      border: 1px solid $grey-lighter
      background-color: $white-super
      //&:hover
        background-color: $white-bis
        box-shadow: 0 0 1px $grey-lighter, 0 0 40px $white-ter
</style>



// WEBPACK FOOTER //
// src/components/personage/personage.vue